<!--
* @description  参数1
* @fileName  byFold
* @author userName
* @date 2024-01-19 17:35:17
!-->
<template>
  <div id="byFold" class="byFold">
    <div class="list-main">
      <div v-for="(item, index) in list" :key="index" class="list-bj">
        <div
          :class="['list-item', { orange: item.isTrue, black: !item.isTrue }]"
          @click="clkxShow(item, index)"
        >
          <span class="item-name">{{ item.name }}</span>
          <i
            :class="{
              'el-icon-arrow-down': !item.isTrue,
              'el-icon-arrow-up': item.isTrue,
            }"
          />
        </div>
        <el-collapse-transition>
        <div v-show="item.isTrue" class="list-card">
          <template v-for="(childItem, i) in item.child">
            <div
              v-if="!childItem.isHide"
              :key="i"
              :class="[childItem.isActive ? 'active-class' : 'default-class', {'margin-top_8': i > 0 }]"
            >
              <img
                :src="
                  require(childItem.isFinish
                    ? '../../assets/img/manage/ic_xd_active.png'
                    : '../../assets/img/manage/ic_xd_normal.png')
                "
                width="12px"
                height="12px"
              />
              <span @click="getActive(childItem, i)">{{ childItem.name }}</span>
            </div>
          </template>
        </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ByFold',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    clkxShow(item, index) {
      this.$emit('isOpen', item, index);
    },
    getActive(item, i) {
      this.$emit('getActive', item, i);
    },
  },
};
</script>
<style scoped lang="scss">
.byFold {
  .list-main {
    padding: 0;
    margin: 0;
    border-radius: 8px;
    div:first-child {
      border-radius: 8px 8px 0 0;
    }
    div:last-child {
      border-radius: 0px 0px 8px 8px;
    }
    .list-bj {
      width: 180px;
      //height: 160px;
      background: #ffffff;
      //border-radius: 8px;
      border: 1px solid rgba(233, 85, 6, 0);
      //margin: 8px 0;
      overflow: hidden;
      cursor: pointer;
      .list-item {
        width: 162px;
        height: 48px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid rgba(233, 85, 6, 0);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 8px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
      }
      .orange {
        color: #3370ff;
        .item-name::before {
          content: '' !important;
          position: relative;
          top: -3px;
          display: inline-block;
          width: 4px;
          height: 4px;
          background: #3370ff;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
      .black {
        color: #333333;
        .item-name::before {
          content: '' !important;
          position: relative;
          top: -3px;
          display: inline-block;
          width: 4px;
          height: 4px;
          background: #aaaaaa;
          border-radius: 50%;
          margin-right: 8px;
        }
      }

      .list-card {
        padding: 4px 8px;
        .default-class {
          padding: 0 8px;
          height: 32px;
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 32px;
          display: flex;
          align-items: center;
          background: rgba(51, 51, 51, 0.03);
          border-radius: 8px;
          box-sizing: border-box;
          img {
            margin: 0 4px;
          }
        }
        .active-class {
          padding: 0 8px;
          height: 32px;
          background: rgba(51,112,255,0.08);
          border-radius: 8px;
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #3370FF;
          line-height: 32px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          img {
            margin: 0 4px;
          }
        }
      }
    }
  }
}
</style>
